import { useNavigate } from "react-router-dom";
import ModalBox from "../../ui/ModalBox";
import FormAccount from "./FormAccount";
import { useState } from "react";
import { Typography } from "@mui/material";

const AddAccount = () => {
  const [open, setOpen] = useState(false);
  //var to navigate another page

  const navigate = useNavigate();
  // close modal function

  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  //open modal function

  const handleSuccess = () => {
    setOpen(true);
  };
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add New Account
      </Typography>
      <FormAccount handleSuccess={handleSuccess} />
      <ModalBox
        open={open}
        handleClose={handleClose}
        text="The add operation has been completed successfully.. You added new Account"
        name="Account"
      />
    </>
  );
};

export default AddAccount;
